export enum EnrollmentStatuses {
  ENROLLED = 'ENROLLED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  REPROVED = 'REPROVED',
  ENROLLMENT_REPROVED = 'ENROLLMENT_REPROVED',
  REFUSED = 'REFUSED',
  EXPIRED = 'EXPIRED',
  REQUEST_EXTENSION = 'REQUEST_EXTENSION',
  INACTIVATED = 'INACTIVATED',
  WAITING_APPROVAL = 'WAITING_APPROVAL',
  WAITING_VACANCIES = 'WAITING_VACANCIES',
  GIVE_UP = 'GIVE_UP',
}

export enum DevelopmentStatus {
  CLOSED = 'CLOSED',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  IN_REVIEW = 'IN_REVIEW',
  EXPIRED = 'EXPIRED',
  INACTIVATED = 'INACTIVATED',
  IN_PROGRESS = 'IN_PROGRESS',
}
